/* file description */
import { message } from 'antd';
import { delAssetModuleByRequest } from '@/common/asset-apis/delAssetModuleByRequest';
import type { UseDeleteFormProp } from './type';

export const useDeleteForm: UseDeleteFormProp = ({
  namespaceID,
  moduleID,
  recordID,
  FetchAPI,
}) => {
  return {
    deleteRequest: async () => {
      if (!recordID) {
        message.error('无法删除');
        return;
      }
      const params = {
        moduleID,
        namespaceID,
        recordKey: recordID!,
      };
      await delAssetModuleByRequest(FetchAPI, params);
    },
  };
};

